/* ============================================================
   The API client as a hook, bound to the signed-in session and the platform's
   config. Kept apart from api/client.ts so the client itself stays free of
   React — the outbox and the tests use it as a plain function.
   ============================================================ */
import { useMemo } from 'react';

import { useAuth } from '../auth/AuthContext';
import { useClientCore } from '../provider';
import { type ApiClient, createApiClient } from './client';

/** React hook: an ApiClient bound to the current auth session. */
export function useApi(): ApiClient {
  const { getIdToken } = useAuth();
  const { config, adapters } = useClientCore();
  return useMemo(
    () =>
      createApiClient({
        baseUrl: config.apiUrl,
        getIdToken,
        headers: config.clientHeaders,
        updates: adapters.updates,
      }),
    [getIdToken, config, adapters],
  );
}
